import {useContext, useEffect} from 'react';

import Layout from './components/layout/Layout';

import {LicenseInfo} from '@mui/x-license';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

import './App.css';
import RouterRoutes from "./routerRoutes";
import ReactGA from 'react-ga4';
import ZiggyContext from "./store/ziggy-context";
import axios from "axios";
import {AuthContext, VersionPrompt} from "@lb/mlib-components";
import LocationsContext from "./libs/locations";

LicenseInfo.setLicenseKey(
    '1c1d423f90788cb79aff463111e5933aTz0xMjg3NjcsRT0xNzk3NzI0Nzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9bXVsdGksS1Y9Mg==',
);

ReactGA.initialize("G-F91XVR3F67");

function App() {
    const ziggyCtx = useContext(ZiggyContext)
    const locationContext = useContext(LocationsContext)

    useEffect(() => {
        axios.defaults.headers.common['X-Warehouse'] = `${ziggyCtx.warehouse ? ziggyCtx.warehouse === 'All' ? '' : ziggyCtx.warehouse : ''}`;
        ziggyCtx.callLoad()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ziggyCtx.warehouse])

    const authCtx = useContext(AuthContext);

    useEffect(() => {
        if (authCtx.isLoggedIn()) {
            locationContext.setLocationsLoading(true)
            axios.get('/config/warehouse')
                .then((response) => locationContext.updateLocations(response.data))
                .finally(() => locationContext.setLocationsLoading(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authCtx]);

    return (

        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <VersionPrompt/>
            <Layout callLoad={ziggyCtx.callLoad}>
                <RouterRoutes/>
            </Layout>
        </LocalizationProvider>
    )
}

export default App
